import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

/**
 * ConfirmActionModal
 * Generic confirm/cancel dialog wrapping Modal (which has no built-in
 * action-button slot). Used for irreversible-ish, single-step actions —
 * convert quote to sale, cancel a sale, mark a sale paid.
 */
const ConfirmActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  confirming = false
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <p>{message}</p>
      <div className="flex-center gap-15 mt-20">
        <button
          type="button"
          onClick={onConfirm}
          disabled={confirming}
          className="btn btn-primary"
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-secondary"
        >
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
